import React from 'react'

const Header = ({
  title,
  subtitle,
  wordClassName = "text-4xl font-bold text-indigo-600 mb-2",
  labelClassName = "text-lg text-gray-600",
  className = "mb-6",
}) => {
  return (
    <div className={className}>
      <div className={wordClassName}>{title}</div>
      <div className={labelClassName}>{subtitle}</div>
    </div>
  );
};

export default Header